import { render, staticRenderFns } from "./ServiceProviderCompanyProfile.vue?vue&type=template&id=0bbc9f9c"
import script from "./ServiceProviderCompanyProfile.vue?vue&type=script&lang=js"
export * from "./ServiceProviderCompanyProfile.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderCompanyProfile.vue?vue&type=style&index=0&id=0bbc9f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports